<template>
  <div class="q_mar_b100px">
    <div class="q_center">
      <van-image class="q_id" fit="cover" :src="convertImg(user.idCardA)"/>
      <p class="q_text_m q_color_gray">身份证正面</p>
      <van-image class="q_id" fit="cover" :src="convertImg(user.idCardB)"/>
      <p class="q_text_m q_color_gray">身份证反面</p>
    </div>
    <div v-if="user.idCardAudit!=null">
      <div class="q_pad_lr15px q_mar_t30px">
        <div class="q_text_l q_bold q_mar_t15px q_mar_b10px">审核信息</div>
      </div>
      <van-cell title="审核结果"
                :value="user.idCardAudit.auditState=='0'?'待审核':user.idCardAudit.auditState=='1'?'审核通过':'审核不通过'"/>
      <van-cell title="提交时间" :value="user.idCardAudit.auditSubmitTime"/>
      <van-cell title="审核时间" :value="user.idCardAudit.auditHandleTime"/>
      <div class="q_pad_lr15px">
        <p class="q_pad_tb10px q_color_gray">审核意见</p>
        <p class="q_justify" v-text="user.idCardAudit.auditReason">不通过理由不通过理由不通过理由不通过理由不通过理由不通过理由</p>
      </div>
    </div>
    <van-goods-action>
      <!-- 修改按钮，在审核通过或待审核状态出现 -->
      <van-goods-action-icon icon="edit" text="申请修改" @click="goToIdentity()"/>
      <van-goods-action-button type="danger" color="#ffffff"
                               :text="user.idCardAudit.auditState=='0'?'待审核':user.idCardAudit.auditState=='1'?'审核通过':'审核不通过'"/>
      <!-- 审核未通过 -->
      <!-- <van-goods-action-button type="danger" color="#ffffff" text="审核未通过" /> -->
    </van-goods-action>
  </div>
</template>

<script>
import {wxCloseShare} from "@/utils/jiutang";

export default {
  name: 'Ident',
  props: {
    msg: String
  },
  data() {
    return {
      user: {
        idCardAudit: {
          auditState: '0'
        }
      }
    }
  },
  created() {
    wxCloseShare()
    this.$modal.loading('加载个人信息')
    this.$store.dispatch("GetInfo").then(res => {
      this.user = res.data
    }).finally(() => {
      this.$modal.closeLoading()
    })
  },
  methods: {
    goToIdentity() {
      this.$router.push({
        path: '/mine/Identity'
      });
    },
  },
}
</script>
<style scoped="scoped">
>>> .van-goods-action-button--last {
  margin-right: 80px;
}

.van-goods-action-button--first {
  margin-left: 80px;
}

.van-goods-action {
  box-shadow: 0 0 10px #f2f3f7;
  height: 60px;
}

.van-goods-action-button {
  color: #999999 !important;
}

.q_id {
  width: 345px;
  height: 217.64px;
  margin: 15px auto;
}
</style>
